import { AssetItemDto, AssetVersionItemDto } from '@api/Api';
import {
  IMediaViewerState,
  MediaViewerActionTypes,
  IMediaViewerAction
} from '@redux/types/mediaViewerType';
import { getStoredAssetsSliderOpen } from '@helpers/assetsSliderOpenStorage';

const INITIAL_STATE: IMediaViewerState = {
  assets: null,
  selectedVersion: null,
  isOpenTranscript: null,
  isAssetsSliderOpen: getStoredAssetsSliderOpen(),
  assetsSliderAnchor: null,
  copiedComments: null
};

const mediaViewerReducer = (
  state = INITIAL_STATE,
  action: IMediaViewerAction
): IMediaViewerState => {
  switch (action.type) {
    case MediaViewerActionTypes.SET_ASSET: {
      return {
        ...state,
        assets: action.payload
      };
    }
    case MediaViewerActionTypes.TOGGLE_ASSET_FAVORITE: {
      if (!state.assets) return state;
      const { isFavorite } = action.payload;
      const assets = { ...state.assets, isFavorite };
      return {
        ...state,
        assets
      };
    }
    case MediaViewerActionTypes.RENAME_ASSET_VERSION: {
      const { name, assetVersionId } = action.payload;
      if (!state.assets?.asset?.versions) return state;
      const newVersions = state.assets.asset.versions.map((el) => {
        if (el.id === assetVersionId) return { ...el, name };
        return el;
      });
      const assets = {
        ...state.assets,
        asset: { ...state.assets.asset, versions: newVersions }
      };
      const selectedVersion = state.selectedVersion
        ? {
            ...state.selectedVersion,
            name
          }
        : null;
      return {
        ...state,
        assets,
        selectedVersion
      };
    }
    case MediaViewerActionTypes.SET_SELECTED_VERSION: {
      const { assets } = state;
      const selectedVersion =
        assets?.asset?.versions.find((item) => item.id === action.payload.id) ||
        null;
      return {
        ...state,
        selectedVersion
      };
    }
    case MediaViewerActionTypes.UPDATE_SELECTED_VERSION: {
      const { assets } = state;
      const { newSelectedVersion } = action.payload;
      const updateAssetVersions: AssetVersionItemDto[] =
        assets?.asset?.versions?.map((version) => {
          if (version.id === newSelectedVersion.id) {
            version = newSelectedVersion;
          }
          return version;
        }) || [];
      return {
        ...state,
        assets: {
          ...assets,
          asset: {
            ...assets?.asset,
            versions: updateAssetVersions
          }
        } as AssetItemDto,
        selectedVersion: action.payload.newSelectedVersion
      };
    }
    case MediaViewerActionTypes.SET_RESET_ASSET_STATE: {
      return {
        ...state,
        assets: null,
        selectedVersion: null
      };
    }
    case MediaViewerActionTypes.SET_COPIED_COMMENTS: {
      return {
        ...state,
        copiedComments: action.payload
      };
    }
    case MediaViewerActionTypes.SET_TOGGLE_OPEN_TRANSCRIPT: {
      const { isOpenTranscript } = action.payload;
      return {
        ...state,
        isOpenTranscript
      };
    }
    case MediaViewerActionTypes.SET_ASSETS_SLIDER_OPEN: {
      return {
        ...state,
        isAssetsSliderOpen: action.payload
      };
    }
    case MediaViewerActionTypes.SET_ASSETS_SLIDER_ANCHOR: {
      return {
        ...state,
        assetsSliderAnchor: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export default mediaViewerReducer;
